var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"priceArea"},_vm._l((_vm.initArr),function(item,index){return _c('div',{key:index,class:[
      {
        'number-item': !isNaN(item),
        'mark-item': isNaN(item)
      },
      _vm.itemClass(_vm.initArr, index)
    ],style:(_vm.itemStyle(_vm.initArr, index))},[_c('div',{staticClass:"num-box"},[_c('ul',{ref:"numberItem",refInFor:true,class:['num-list', { noTrans: isNaN(item) }]},[(!isNaN(item))?_vm._l((_vm.nums),function(n,i){return _c('li',{key:("" + (index + '-' + i))},[_vm._v(_vm._s(n))])}):[_c('li',{staticClass:"comma"},[_vm._v(_vm._s(item))])]],2)])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }